export default "__VITE_ASSET__cbd1e6d9__"